import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import NumberSetting from "../../../../../../../components/global/Settings/NumberSetting";
import StringSetting from "../../../../../../../components/global/Settings/StringSetting";
import { useGetSettingsQuery, useGetSettingsForRelationQuery } from "../../../../../../../newapi/global/generalApiSlice";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";
import { useGetInvoiceProductsSelectQuery } from "../../../../../../../newapi/financial/invoiceProductSlice";

const ReturnPortal = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [view, setView] = useState({
    title: 'return_portal',
    icon: <AssignmentReturnIcon />,
  });

  const { data: settings} = useGetSettingsQuery("return_portal");
  const { data: invoiceProducts, productsIsLoading } = useGetInvoiceProductsSelectQuery();
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  const [invoiceProductOptions, setInvoiceProductOptions] = useState([]);
  useEffect(() => {
    if (invoiceProducts && invoiceProducts.length > 0) {
      setInvoiceProductOptions([{id: null, name: t('none')}, ...invoiceProducts]);
    }
  }, [invoiceProducts])

  
  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);

  return (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 2,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_return_portal_title")}</Subheading>
            <Text light>{t("core_return_portal_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>
        
        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            display:"flex",
            flexDirection:"column",
            gap:3,
            pt:3,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
              gap:2.5,
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <NumberSetting
              manualSave
              hideSaveButton
              onChange={handleChange}
              maxWidth={240}
              settings={settings}
              skey="return_portal_return_cost"
            />
          </Box>
          
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <StringSetting 
              manualSave
              onChange={handleChange}
              maxWidth={400} 
              settings={settings} 
              skey="return_portal_mollie_key"
              placeholder="sk_live_xxxxxxxxxxxxxxxxxxxxxxxx"
            />
          </Box>
          
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <DropdownSetting
            manualSave
            onChange={handleChange}
            bold={false}
            valueKey="id"
            showNullAsSelected
              searchOptions={{
                  enabled: true,
                  placeholder: t("search")
              }}
              styles={{
                  minWidth:300
              }}
              settings={settings} 
              objects={invoiceProductOptions ?? []} 
              noselection={"choose_option"}
              skey="return_portal_administration_costs"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReturnPortal;